import { ReactElement } from 'react';

import { getChain } from 'modules/api/utils/getChain';
import { useConnection } from 'modules/auth/hooks/useConnection';
import {
  ILoadingButtonProps,
  LoadingButton,
} from 'modules/common/components/LoadingButton';
import { KnownDialogs, useDialog } from 'modules/dialogs';
import { globalTranslation, useTranslation } from 'modules/i18n';

interface IGuardButtonProps extends ILoadingButtonProps {
  isConnectedOnly?: boolean;
}

const appChainConfig = getChain();

export function GuardButton({
  isConnectedOnly,
  ...props
}: IGuardButtonProps): ReactElement | null {
  const { isConnected, chainId: currentChainId } = useConnection();
  const { t, keys } = useTranslation(globalTranslation);

  const { onOpen } = useDialog(KnownDialogs.connect);

  if (!isConnected) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { disabled, loading, children, ...buttonProps } = props;

    return (
      <LoadingButton {...buttonProps} onClick={onOpen}>
        {t(keys.common.connectWallet)}
      </LoadingButton>
    );
  }

  if (currentChainId !== appChainConfig.id) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { disabled, loading, children, ...buttonProps } = props;

    return (
      <LoadingButton {...buttonProps} disabled>
        {t(keys.common.unsupportedNetwork)}
      </LoadingButton>
    );
  }

  if (isConnectedOnly) {
    return null;
  }

  return <LoadingButton {...props} />;
}
